import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { SectionHead, Btn, Reveal, Photo } from "../components/ui.js";
import { POSTS, TAGS } from "../data/blog.js";

/* ============================================================
   LEVELUP ONE — Blog list (layout อ้างอิงเว็บต้นแบบ)
   hero carousel → บทความแนะนำ → บทความทั้งหมด (ค้นหา+แท็ก) → newsletter
   ============================================================ */

const PostCard = ({ p }) => (
  <Link to={`/blog/${p.slug}`} className="nx-post d-block">
    <Photo src={p.cover} alt={p.title} fallback="📝" />
    <div className="nx-post__body">
      <span className="nx-post__tag">{p.tag}</span>
      <h3 className="nx-post__title">{p.title}</h3>
      <p className="nx-card__desc">{p.excerpt}</p>
      <div className="nx-post__meta">
        <span>🗓 {p.date}</span>
        <span>⏱ {p.read}</span>
      </div>
    </div>
  </Link>
);

export default class Blog extends Component {
  state = { active: "ทั้งหมด", q: "", slide: 0 };

  componentDidMount() {
    loading(false);
    window.scrollTo(0, 0);
    const tag = new URLSearchParams(window.location.search).get("tag");
    if (tag && TAGS.includes(tag)) this.setState({ active: tag });
  }

  pick = (t) => {
    this.setState({ active: t });
    window.history.replaceState(null, "", t === "ทั้งหมด" ? "/blog" : `/blog?tag=${encodeURIComponent(t)}`);
  };

  render() {
    const { active, q, slide } = this.state;
    const featured = POSTS.filter((p) => p.featured);
    const hero = featured[slide % featured.length] || POSTS[0];

    let list = active === "ทั้งหมด" ? POSTS : POSTS.filter((p) => p.tag === active);
    if (q.trim()) {
      const kw = q.trim().toLowerCase();
      list = list.filter((p) => (p.title + p.excerpt + p.tag).toLowerCase().includes(kw));
    }

    return (
      <div className="nx">
        <Navbar />

        {/* ===== HERO CAROUSEL ===== */}
        <section className="nx-bloghero">
          <div className="container">
            <div className="nx-carousel">
              <button className="nx-carousel__arrow nx-carousel__arrow--prev" onClick={() => this.setState({ slide: (slide - 1 + featured.length) % featured.length })} aria-label="ก่อนหน้า">‹</button>
              <button className="nx-carousel__arrow nx-carousel__arrow--next" onClick={() => this.setState({ slide: (slide + 1) % featured.length })} aria-label="ถัดไป">›</button>
              <Link to={`/blog/${hero.slug}`} className="nx-bloghero__slide d-block">
                <Photo src={hero.cover} alt={hero.title} fallback="📰" />
                <div className="nx-bloghero__body">
                  <span className="nx-bloghero__tag">{hero.tag}</span>
                  <h1 className="nx-bloghero__title">{hero.title}</h1>
                  <p className="nx-bloghero__excerpt">{hero.excerpt}</p>
                  <div className="nx-bloghero__meta">
                    <span>✍️ {hero.author.name}</span>
                    <span>🗓 {hero.date}</span>
                    <span>⏱ {hero.read}</span>
                  </div>
                </div>
              </Link>
              <div className="nx-carousel__dots">
                {featured.map((_, i) => (
                  <button key={i} className={`nx-carousel__dot ${i === slide % featured.length ? "is-active" : ""}`} onClick={() => this.setState({ slide: i })} aria-label={`สไลด์ ${i + 1}`} />
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ===== FEATURED ===== */}
        <section className="nx-section">
          <div className="container">
            <Reveal><SectionHead eyebrow="FEATURED" title="บทความแนะนำ" /></Reveal>
            <div className="row g-4 mt-2">
              {featured.map((p, i) => (
                <div className="col-12 col-md-4" key={p.slug}>
                  <Reveal delay={i * 60}><PostCard p={p} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ===== ALL POSTS ===== */}
        <section className="nx-section nx-bg-surface">
          <div className="container">
            <Reveal><SectionHead eyebrow="ARTICLES" title="บทความทั้งหมด" /></Reveal>

            <div className="nx-search mb-3 mt-2">
              <input value={q} onChange={(e) => this.setState({ q: e.target.value })} placeholder="ค้นหาบทความ..." />
            </div>
            <div className="nx-chip-filter mb-4">
              {TAGS.map((t) => (
                <button key={t} className={active === t ? "is-active" : ""} onClick={() => this.pick(t)}>{t}</button>
              ))}
            </div>

            <div className="row g-4">
              {list.map((p, i) => (
                <div className="col-12 col-sm-6 col-lg-4" key={p.slug}>
                  <Reveal delay={(i % 3) * 50}><PostCard p={p} /></Reveal>
                </div>
              ))}
            </div>
            {list.length === 0 && <p className="text-center nx-muted py-5">ไม่พบบทความที่ตรงกับการค้นหา</p>}
          </div>
        </section>

        {/* ===== NEWSLETTER ===== */}
        <section className="nx-section nx-news-band">
          <div className="container">
            <div className="row align-items-center g-4">
              <div className="col-12 col-lg-7">
                <Reveal>
                  <span className="nx-eyebrow">NEWSLETTER</span>
                  <h2 className="nx-heading mt-3">บทความและเทรนด์<br />ส่งตรงถึงคุณ</h2>
                  <p style={{ color: "#c7d2fe", maxWidth: 460 }}>เทรนด์ AI, เคล็ดลับ และกรณีศึกษาการนำเทคโนโลยีไปใช้จริง เดือนละครั้ง ไม่มีสแปม ยกเลิกได้ทุกเมื่อ</p>
                </Reveal>
              </div>
              <div className="col-12 col-lg-5">
                <Reveal delay={100}>
                  <form className="nx-news-form" onSubmit={(e) => { e.preventDefault(); e.currentTarget.reset(); }}>
                    <input type="email" placeholder="อีเมลของคุณ" required />
                    <button type="submit" className="nx-btn nx-btn--accent">สมัครรับข่าว</button>
                  </form>
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        {/* ===== TAGLINE ===== */}
        <section className="nx-section--tight nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="nx-tagline">
                <h2 className="nx-tagline__title">สร้างจากไทย — <span className="nx-gradient-text">ส่งมอบทั่วโลก</span></h2>
                <div className="nx-tagline__card">
                  <span className="nx-eyebrow">เริ่มโปรเจกต์กับเรา</span>
                  <p className="nx-card__desc my-3">คุยฟรี 30 นาที ไม่มีข้อผูกมัด แล้วเราจะช่วยประเมินแนวทางให้</p>
                  <Btn to="/booking" block>พูดคุยกับเรา</Btn>
                </div>
              </div>
            </Reveal>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}
